export enum OrderFormatEnum {
  CHEQUE_UNITY = 'CHEQUE_UNITY',
  CARD = 'CARD',
  CHEQUE_BOOKLET = 'CHEQUE_BOOKLET'
}
